import { api } from './api';

const getCardImages = async (vouId) => {
    const response = await api({
        url: `CardImages/getByVouId`,
        method: 'GET',
        id:'CardImages-getByVouId',
        params: {
            vouId,
        },
        cache: {
            ttl: 1000 * 60 * 60 * 24 * 30
        }
    });
    return response.data;
};
const cardImagesGetList = async (pageNumber = 1, pageSize = 10) => {
    const response = await api({
        url: `CardImages/GetCardImageDtoListQuery`,
        method: 'GET',
        params: {
            Page: pageNumber,
            PageSize: pageSize,
        },
    });
    return response.data;
};

const cardImagesUpdate = async (data) => {
    const response = await api({
        url: `CardImages`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const cardImageDelete = async (data) => {
    const response = await api({
        url: `CardImages`,
        method: 'DELETE',
        data,
    });
    return response.data;
};

const cardImagesAdd = async (data) => {
    const response = await api({
        url: `CardImages`,
        method: 'POST',
        data,
    });
    return response.data;
};

const cardImagesServices = {
  getCardImages,
  cardImagesGetList,
  cardImagesUpdate,
  cardImageDelete,
  cardImagesAdd,
};

export default cardImagesServices;
